import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { formatDate } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormControlState } from '@angular/forms';


export interface TimeData {
  time: number;
}

@Component({
  selector: 'app-time-travel-dialog',
  templateUrl: './time-travel-dialog.component.html',
  styleUrls: ['./time-travel-dialog.component.scss']
})
export class TimeTravelDialogComponent implements OnInit {



  dateControl = new FormControl({ value: new Date(), disabled: false });

  @ViewChild('picker')
  picker: any;


  constructor(private dialogRef: MatDialogRef<TimeTravelDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: TimeData) {
    this.dateControl.setValue(new Date(data.time));
  }

  ngOnInit(): void {
  }

  close(): void {
    console.log('dateControl', this.dateControl?.value);
    this.dialogRef.close({ time: this.dateControl?.value });
  }
}
